import { render } from "./PageNotLoad.vue?vue&type=template&id=f0243b8a&scoped=true"
import script from "./PageNotLoad.vue?vue&type=script&lang=js"
export * from "./PageNotLoad.vue?vue&type=script&lang=js"

import "./PageNotLoad.vue?vue&type=style&index=0&id=f0243b8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0243b8a"]])

export default __exports__